<!-- TODO - this is a temporary solution, correct solution would be to create a general create account form that would read its configuration from assets/configuration/[cr|cwk]/configuration.ts -->
<form class="my-3 fix-row" #studentForm="ngForm">

  <!-- AVATAR -->
  <div class="col-12 d-flex flex-column align-items-center">
    <div class="image-container mb-5 position-relative" (click)="switchAvatars()">
      <img class="bg-body border border-3 border-warning img-fluid rounded-circle" src="https://d3t4xfu733v2tb.cloudfront.net/web/account/avatars/{{ student.AvatarPath || 'empty.png' }}" alt="Student avatar" loading="lazy" width="200" height="200" />
      <fa-icon class="icon-overlay" [icon]="faPen"></fa-icon>
    </div>

    <!-- AVATARS COLLECTION -->
    <div class="card mb-3 w-100" *ngIf="isAvatarsShown">
      <div><ng-container *ngTemplateOutlet="avatarsTemplate; context: { gender: 'g' }"></ng-container></div>
      <div><ng-container *ngTemplateOutlet="avatarsTemplate; context: { gender: 'b' }"></ng-container></div>

      <ng-template #avatarsTemplate let-gender="gender">
        <div class="d-flex flex-wrap">
          <div class="p-2" *ngFor="let avatar of filterAvatarsByGender(gender)" (click)="setAvatar(avatar)" [ngClass]="{'avatar-selected' : avatar === student.AvatarPath}">
            <img width="30px" src="https://d3t4xfu733v2tb.cloudfront.net/web/account/avatars/{{ avatar }}" alt="Avatar icon" loading="lazy"/>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- FIRST NAME -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="firstName" id="firstName" [ngClass]="{'cwk-form-control-invalid': firstName.errors && firstName.errors['pattern'], 'cwk-form-control-missing': !student.FirstName && (firstName.dirty || firstName.touched)}" [(ngModel)]="student.FirstName" maxlength="128" #firstName="ngModel" pattern="^[^@()&]+$" placeholder="First Name" required>
      <label for="firstName" i18n>First Name</label>
      <small class="ms-3 theme-error-color" *ngIf="!student.FirstName && (firstName.dirty || firstName.touched)">This field is required</small>
    </div>
  </div>

  <!-- MIDDLE NAME -->
  <div class="col-12 col-md-6" *ngIf="environment.project === 'cwk'">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="middleName" id="middleName" [ngClass]="{'cwk-form-control-invalid': middleName.errors && middleName.errors['pattern']}" [(ngModel)]="student.MiddleName" maxlength="128" #middleName="ngModel" pattern="^[^@()&]+$" placeholder="Middle Name">
      <label for="middleName" i18n>Middle Name</label>
    </div>
  </div>

  <!-- LAST NAME -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="lastName" id="lastName" [ngClass]="{'cwk-form-control-invalid': lastName.errors && lastName.errors['pattern'], 'cwk-form-control-missing': !student.LastName && (lastName.dirty || lastName.touched)}" [(ngModel)]="student.LastName" maxlength="128" #lastName="ngModel" pattern="^[^@()&]+$" placeholder="Last Name" required>
      <label for="lastName" i18n>Last Name</label>
      <small class="ms-3 theme-error-color" *ngIf="!student.LastName && (lastName.dirty || lastName.touched)">This field is required</small>
    </div>
  </div>

  <!-- NICKNAME -->
  <div class="col-12 col-md-6" *ngIf="environment.project === 'cwk'">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="nickname" id="nickname" [ngClass]="{'cwk-form-control-invalid': nickname.errors && nickname.errors['pattern']}" [(ngModel)]="student.Nickname" maxlength="128" #nickname="ngModel" pattern="^[^@()&]+$" placeholder="Nickname">
      <label for="nickname" i18n>Nickname</label>
    </div>
  </div>

  <!-- BIRTH YEAR -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <select #birthYear="ngModel" class="cwk-form-control form-control form-select" name="birthYear" [(ngModel)]="student.BirthYear" [ngClass]="{'cwk-form-control-missing': !student.BirthYear && (birthYear.dirty || birthYear.touched)}" required>
        <option [ngValue]="null" disabled>Birth Year</option>
        <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
      </select>
      <label for="birthYear" i18n>Birth Year</label>
      <small class="ms-3 theme-error-color" *ngIf="!student.BirthYear && (birthYear.dirty || birthYear.touched)">This field is required</small>
    </div>
  </div>

  <!-- BIRTH MONTH -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <select #birthMonth="ngModel" class="cwk-form-control form-control form-select" name="birthMonth" [(ngModel)]="student.BirthMonth" [ngClass]="{'cwk-form-control-missing': (student.BirthMonth === null) && (birthMonth.dirty || birthMonth.touched)}" required>
        <option [ngValue]="null" disabled>Birth Month</option>
        <option *ngFor="let month of months; index as i" [ngValue]="i">{{ month }}</option>
      </select>
      <label for="birthMonth" i18n>Birth Month</label>
      <small class="ms-3 theme-error-color" *ngIf="(student.BirthMonth === null) && (birthMonth.dirty || birthMonth.touched)">This field is required</small>
    </div>
  </div>

  <!-- PRONOUN -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <select class="cwk-form-control form-control form-select" name="pronoun" [(ngModel)]="student.Pronoun" [ngClass]="{'cwk-form-control-missing': (student.Pronoun === null) && (pronoun.dirty || pronoun.touched)}" #pronoun="ngModel" required>
        <option [ngValue]="null" disabled>Preferred Pronouns</option>
        <option [ngValue]="PreferredPronouns.HE">He/him/his</option>
        <option [ngValue]="PreferredPronouns.SHE">She/her/hers</option>
        <option [ngValue]="PreferredPronouns.THEY">They/them/theirs</option>
        <option [ngValue]="PreferredPronouns.OTHER">Other - please specify</option>
      </select>
      <label for="pronoun" i18n>Preferred Pronoun</label>
    </div>
  </div>

  <!-- OTHER PRONOUN -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <input class="cwk-form-control form-control" [disabled]="student.Pronoun !== PreferredPronouns.OTHER" maxlength="32" name="PronounOther" [ngClass]="{'cwk-form-control-missing': (student.Pronoun === PreferredPronouns.OTHER) && !student.PronounOther && (pronounOther.dirty || pronounOther.touched)}" [(ngModel)]="student.PronounOther" placeholder="Other Pronoun" #pronounOther="ngModel" required size="32" type="text" />
      <label for="pronounOther" i18n>Other Pronoun</label>
      <small class="ms-3 theme-error-color" *ngIf="(student.Pronoun === PreferredPronouns.OTHER) && !student.PronounOther && (pronounOther.dirty || pronounOther.touched)">This field is required</small>
    </div>
  </div>

  <!-- ACCOUNT NAME (ASK FOR NEW STUDENTS ONLY) -->
  <div class="col-12 col-md-6" *ngIf="!student.StudentId">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="account" id="account" [ngClass]="{'cwk-form-control-invalid': (account.errors && account.errors['pattern']) || (errorSaving === 'DUPLICATE') || (student.Account && (student.Account.length < 8) && account.touched)}" [(ngModel)]="student.Account" (ngModelChange)="onAccountChange()" maxlength="32" minlength="8" #account="ngModel" pattern="^[A-Za-z0-9]+$" placeholder="Account Name">
      <label for="account" i18n>Account Name (OPTIONAL)</label>
      <small class="ms-3 theme-error-color" *ngIf="student.Account && account.errors && account.errors['pattern']">Invalid value - only alphanumeric characters are allowed</small>
      <small class="ms-3 theme-error-color" *ngIf="student.Account && (student.Account?.length < 8) && account.touched && !(account.errors && account.errors['pattern'])">Too short - at least 8 characters required</small>
      <small class="ms-3 theme-error-color" *ngIf="errorSaving === 'DUPLICATE'">The account with the same name already exists. Please choose another one.</small>
    </div>
  </div>

  <!-- MEDICAL NOTES FLAG -->
  <div class="col-12" *ngIf="environment.project === 'cwk'">
    <div class="mb-3">

      <!-- Medical notes -->
      <div class="form-check">
        <label class="form-check-label">
          <input type="checkbox" class="form-check-input" name="student.IsMedicalNotes" [(ngModel)]="student.IsMedicalNotes">
          My child has a diagnosable condition or an additional medical information I'd like to provide
        </label>
      </div>
    </div>
  </div>

  <!-- MEDICAL NOTES -->
  <div class="col-12" *ngIf="student.IsMedicalNotes">
    <div class="form-floating mb-3">
      <textarea class="cwk-form-control form-control medical-notes" maxlength="1024" #medicalNotes="ngModel" name="medicalNotes" [ngClass]="{'cwk-form-control-missing': !student.MedicalNotes && (medicalNotes.dirty || medicalNotes.touched)}" [(ngModel)]="student.MedicalNotes" placeholder="Medical Notes" required></textarea>
      <label for="medicalNotes" i18n>Medical Notes</label>
    </div>
  </div>

  <!-- BUTTONS -->
  <div class="col-12 d-grid d-sm-flex gap-3 justify-sm-content-between mt-4">

    <!-- CANCEL -->
    <button id="student-form-cancel" class="btn btn-warning me-5 w-100" (click)="cancel()" type="button">Cancel</button>

    <!-- CREATE STUDENT PROFILE BUTTON -->
    <button id="student-form-submit" type="submit" class="btn btn-warning w-100" (click)="save()" [disabled]="isSaving || !studentForm.valid">
      <span *ngIf="isSaving; else saveButton">
        <fa-icon class="me-1" [icon]="faSpinner" animation="spin"></fa-icon>Saving...
      </span>
      <ng-template #saveButton>Save</ng-template>
    </button>
  </div>
  <div class="mt-1 text-end theme-error-color" *ngIf="isInvalidSubmitted">
    <small>Required fields missing or invalid</small>
  </div>
</form>

<!-- ERROR CREATING ACCOUNT -->
<cwk-error-alert *ngIf="errorSaving && !['DUPLICATE'].includes(errorSaving)" [error]="errorSaving"></cwk-error-alert>
